import React, { FC } from 'react'

import { RecipeForm, RecipeFormProps } from './RecipeForm'

import { PageLayout } from 'Components'
import SidebarUserFood from 'Components/SidebarUserFood/SidebarUserFood'

type CreateRecipePageProps = RecipeFormProps

export const CreateRecipePage: FC<CreateRecipePageProps> = ({ ...recipeFormProps }) => {
  return (
    <PageLayout variant="smallcircle">
      <div className="container max-900">
        <div className="row">
          <SidebarUserFood />

          <div className="col-12 col-lg-8">
            <h1>Rezept erstellen</h1>

            <p>
              Hier können Sie Ihr eigenes Rezept hinterlegen. Füllen Sie einfach die Felder mit den Informationen zu
              Ihrem Rezept aus und klicken Sie anschliessend auf «Speichern». Nun können Sie das neue Rezept über die
              Suche Ihrem Tagebuch hinzufügen.
            </p>

            <RecipeForm {...recipeFormProps} />
          </div>
        </div>
      </div>
    </PageLayout>
  )
}
